module.exports = __webpack_public_path__ + "img/fushimi-HP-pattern002.8acc1a37.png";